import React, { createContext, useContext, useEffect, useState } from "react";
import theme from "../services/themeServices";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => theme.getLanguage());

    const switchLanguage = (lang) => {
        setLanguage(lang);
        theme.setLanguage(lang);
    };

    useEffect(() => {
        theme.setLanguage(language);
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, switchLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
